import React, { useEffect, useState } from 'react';
import '../../css/Dashboard.css';
import { useDashboardData } from '../SalesDashboard/DashboardDataContext';

const DepartingPackages: React.FC = () => {
  const [items, setItems] = useState<{ title: string; date: string; customer: string }[]>([]);
  const { data } = useDashboardData();
  useEffect(() => {
    if (!data) return;
    const list = (data.departures || []).map(d => ({
      title: d.title,
      date: new Date(d.date).toLocaleDateString(),
      customer: d.customer,
    }));
    setItems(list);
  }, [data]);

  return (
    <div className="card">
      <h4 className="card-title">Departing This Week</h4>
      <ul className="list">
        {items.map((it, i) => (
          <li key={i} className="list-item" style={{ display:'block' }}>
            <div className="li-title">{it.title}</div>
            <div className="li-sub">Customer: {it.customer} · Departure: {it.date}</div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DepartingPackages;
